export const Localization = {
    // English
    en: {
      title: "Hybra",
      PrivacyPolicy: {
        effectiveDate: "Effective Date: June 10, 2025",
        intro:
          "At Hybra (by Weightliftr), we respect your privacy and are committed to protecting the personal information you share with us. This policy explains how we collect, use, and safeguard your data when using the Hybra mobile app.",
  
        sections: [
          {
            title: "1. Information We Collect",
            content: `- Email address (for login or account creation)
  - Workout data (exercises, sets, reps, weights, cardio sessions)
  - App usage data (e.g., feature usage, crashes, diagnostics)
  - Device type and operating system`,
          },
          {
            title: "2. How We Use Your Information",
            content: `We use your data to:
  • Operate and improve the Hybra app
  • Save and sync workouts across devices
  • Provide personalized workout suggestions
  • Analyze usage trends to improve features
  • Provide customer support`,
          },
          {
            title: "3. Data Sharing",
            content:
              "We do not sell or rent your data. We may share it with trusted third-party service providers who help us operate the app, and only as needed. We may disclose information to comply with the law or to protect user safety.",
          },
          {
            title: "4. Data Retention and Security",
            content:
              "We retain your data only as long as needed to provide our services. Data is securely stored using encryption and best practices. However, no online service is 100% secure, and we cannot guarantee complete protection.",
          },
          {
            title: "5. Tracking and Analytics",
            content:
              "Hybra does not use your data for tracking across other apps or websites. We only collect anonymized usage analytics to improve app functionality.",
          },
          {
            title: "6. Your Rights",
            content: `You can:
  • Access or delete your data
  • Delete your account
  • Opt out of email communications
  
  To make a request, contact us at willjones@weightliftr.com.`,
          },
          {
            title: "7. Changes to This Policy",
            content:
              "We may update this policy as needed. We’ll notify you of major changes via email or through the app.",
          },
          {
            title: "8. Contact",
            content:
              "Questions? Contact Will Jones at willjones@weightliftr.com.",
          },
        ],
  
        backToHome: "Back to Home",
      },
    },
  };
  